// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {ChangeEvent, Fragment, useContext, useEffect, useMemo, useRef,
    useState} from 'react';
import {Redirect, useHistory} from 'react-router-dom';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Icon_x_close from '../../../../hola/pub/img/hola2023/icons/16/x_close.svg';
import {get_list_of_products} from '../../../../hola/pub/ui/pro/products';
import {t_country} from '../dashboard/country_list';
import {Input} from '../../../../hola/pub/lib/input.js';
import {Button} from '../../../../hola/pub/lib/button';
// @ts-ignore
import {get_country_object} from '/util/country.js';
import Icon_check from '../../../../hola/pub/img/hola2023/icons/8/check.svg';
import Icon_chevron_up from '../../../../hola/pub/img/hola2023/icons/16/chevron_up.svg';
import Icon_chevron_down from '../../../../hola/pub/img/hola2023/icons/16/chevron_down.svg';
import Icon_sneakers from '../../img/icons/16/sneakers.svg';
import Icon_tickets from '../../img/icons/16/tickets.svg';
import etask from 'zetask';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {Proxy_type, t_order, t_orders, t_zone_group} from '../../../../hola/pub/ui/pro/cp/orders';
import {t_countries} from '../../lib/use_dashboard_data';
import {configured_proxies_create, DEFAULT_IPS_AMOUNT,
    group_order_by_id, order_by_id} from '../dashboard/utils';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';
import {use_qs_with_set} from '../../../../hola/pub/lib/use_qs';
import {Configuration_snippet} from './configure';
import {Radio} from '../../../../hola/pub/lib/radio';
import {Toggle_switch} from '../lib/toggle_switch';
import {use_app_context} from '../../lib/app_context';
import {Kyc_block} from '../dashboard/kyc/kyc';
import {www_hola} from 'hola_opt';
import {api} from '../../lib/api';
import {Lottie} from '../../../../shared/ui/lottie';
import {Country_selector_v2} from '../dashboard/country_selector_v2';

import styles from './configure.module.less';

const Btn_loader = ()=>{
    return <Lottie autoplay loop width="96" height="96"
      src={toolip_img_url('animation/toolip_loader_72_grey.json')}/>;
};

interface i_config_item {
    country: string;
    amount: number;
    socks5?: boolean;
}
interface i_config_state {
    added: i_config_item[];
    adding: i_config_item;
}

const Count_input = ({value, on_change, label, placeholder})=>{
    return <div className={styles.count_input}>
      <Input type="number" cl={styles.count_input} no_margin
        label={label} value={value} on_change={on_change}
        placeholder={placeholder}/>
      <div className={styles.btns}>
        <button onClick={()=>on_change((value||0)+1)}>
          <Icon_chevron_up/></button>
        <button onClick={()=>!!value && on_change(value-1)}>
          <Icon_chevron_down/></button>
      </div>
    </div>;
};

const get_country_objects = (countries: string[])=>{
    return countries
        ?.map(x=>get_country_object(x))
        ?.sort((a, b)=>a.name_low.localeCompare(b.name_low)) ?? [];
};

const get_proxy_host = ()=>
    www_hola.site=='oculus' ? 'proxy.oculus-proxy.com' : 'proxy.toolip.io';

interface i_config_line_props {
    countries: t_country[];
    update: (idx: number | null, item: i_config_item | null)=>void;
    add: (item: i_config_item)=>void;
    index?: number;
    max?: number;
    value: i_config_item;
    ui_add_icon?: React.ReactNode
    ui_label_country: string
    ui_labels_always_visible?: boolean
    ui_socks5_opts?: {
        next_line?: boolean
        label?: string
    }
    render_flag?: (country: string)=>JSX.Element;
}

const Config_line = (props: i_config_line_props)=>{
    const {countries, update, add, max, value, index, ui_socks5_opts} = props;
    const {theme} = useContext(Settings_context);
    useEffect(()=>{
        if (index == null && !value.country)
        {
            update(index, {country: countries[0].code,
                amount: value.amount, socks5: value.socks5});
        }
    }, [countries]);
    const show_label = index == 0 || index == null
      || props.ui_labels_always_visible;
    return <div className={styles.config_line}>
      <Country_selector_v2
        all={countries}
        country={value.country}
        on_country_change={new_country=>{
          update(index, {...value, country: new_country});
        }}
        render_flag={props.render_flag}
        label={show_label ? props.ui_label_country : null}
        cls={styles.c_list}
        item_cls={styles.c_item}
        with_filter
      />
      <Count_input value={value.amount}
        placeholder={`Up to ${Math.max(0, max)}`}
        label={show_label ? 'How many proxies' : null}
        on_change={(new_val: string, ev: ChangeEvent)=>{
          if (+new_val < 0 && ev)
            return void ev.preventDefault();
          update(index, {...value, amount: +new_val});
        }}
      />
      <Toggle_switch options={[
        {value: false, label: 'http/https'}, {value: true, label: 'SOCKS5'}]}
        value={!!value.socks5}
        label={show_label ? ui_socks5_opts?.label ?? 'Protocol' : null}
        cls={ui_socks5_opts?.next_line && styles.socks5_next_line}
        on_change={s5=>update(index, {...value, socks5: s5})} />
      {index != null ? <div className={cn(styles.added,
        ui_socks5_opts?.next_line && styles.add_full_width)}>
        <Icon_check/>
        <span className={cn(theme.p2, theme.med, theme.color_n700)}>
          Added</span>
      </div> : <Button size={'md'} round={false} color='black' no_jump
        caption={<>Add {props.ui_add_icon}</>}
        disabled={max<0 || !value.amount}
        cls={cn(styles.add_btn,
          ui_socks5_opts?.next_line && styles.add_full_width)}
        on_click={()=>add(value)}
      />}
    </div>;
};

interface i_configure_proxies_props {
    orders: t_orders;
    zone_groups?: t_zone_group[];
    countries: t_countries;
    active?: boolean;
    ui_config: {
        table_icon?: JSX.Element
        add_icon?: JSX.Element
        label_country: string
        labels_always_visible?: boolean
        configure_always_visible?: boolean
        btn_loader?: JSX.Element
        show_virtual_conf_for_gb?: boolean
        socks5_opts?: {
            next_line?: boolean
            label?: string
        }
        render_flag?: (country: string)=>JSX.Element;
    }
}

export const Configure_all = (props: i_configure_proxies_props)=>{
    const {params} = use_pathname();
    return <>
      <Configure_group {...props}
        active={!!params.configure_group}
      />
      <Configure_proxies
        active={!!(params.configure_proxies && params.type)}
        {...props}
      />
    </>;
};

export const Configure_group = (props: i_configure_proxies_props)=>{
    const {zone_groups, ui_config, active} = props;
    const {theme} = useContext(Settings_context);
    const {kyc, dashboard} = use_app_context();
    const {dispatch} = dashboard;
    const {params, set} = use_pathname();
    const _id = params.configure_group;
    const group = zone_groups?.find(g=>g._id==_id);
    const [loading, set_loading] = useState(false);
    const [err, set_err] = useState<string|null>(null);
    const history = useHistory();
    useEffect(()=>{
        if (active && !group)
            set({configure_group: undefined});
    }, [active, group]);
    const visible = active && !!group;
    const products = get_products(group?.enable_additional_usage_charges);
    useEffect(()=>{
        if (visible)
            document.body.classList.add('hola_modal-no_body_scroll_stack');
        else
            document.body.classList.remove('hola_modal-no_body_scroll_stack');
    }, [visible]);
    const [c_type, set_c_type] = useState<Proxy_type>(Proxy_type.EV_RES);
    const show_kyc_block = c_type == Proxy_type.EV_RES
        && kyc.info.status != 'completed';
    return <div className={cn(styles.overlay,
      visible && styles.visible)} onClick={()=>{
        set({configure_group: undefined, type: undefined});
      }}>
        <div className={cn(styles.configure_group, styles[params.type])}
          onClick={ev=>{ ev.stopPropagation(); }}>
          <div className={styles.header}>
            <p className={cn(styles.title, theme.color_n700)}>
              Zone configuration</p>
          </div>
          {products.length > 1 && <div className={styles.vertical}>
            <p className={cn(theme.color_n500, styles.text)}>
              Select the vertical to define your zone</p>
            <div className={styles.types}>
              {products.map(p=>
                <div key={p.value} className={cn(styles.radio_btn,
                  c_type==p.value && styles.checked)}>
                  <Radio value={p.value}
                    checked={c_type==p.value}
                    label={p.label}
                    on_change={()=>set_c_type(p.value)}
                    size={'sm'}
                  />
              </div>)}
            </div>
          </div>}
          <p className={cn(theme.color_n500, styles.text)}>
            Access to the code for your selected vertical is available
            here. Click on Configure to get the full code and details
          </p>
          <Configuration_snippet lang="curl" example with_line_numbers
            order={{
              type: c_type,
              unit: 'gb',
            } as t_order}
            generated={[{
              login: '_login_-country-US-session-123',
              host: get_proxy_host(),
            }]}
          />
          <div className={styles.config_bottom}>
            {!show_kyc_block && <Button size={'md'}
              caption={loading ? ui_config.btn_loader ?? <Btn_loader/>
              : 'Configure Proxies'}
              cls={styles.config_btn} fit round={false}
              color='black' no_jump on_click={()=>{
                etask(function*(){
                  set_err(null);
                  set_loading(true);
                  try {
                    const res = yield dispatch({type: 'create_zone_for_group',
                      payload: {group_id: _id, type: c_type}});
                    history.push(`/dashboard/page/plans`
                      +`/zone_group/${group._id}`
                      +`/configure_proxy/${res.zone?._id}`
                      +`/type/${res.zone?.type}?success=true`);
                  } catch(e){
                    set_err(e.hola_info?.response_text);
                  }
                  set_loading(false);
                });
              }}
            />}
            {show_kyc_block && <Kyc_block site={www_hola.site}
              btn_color='black' caption='Verify now'
              on_ok={()=>set({configure_group: undefined, type: undefined})}
              />}
          </div>
          <div className={cn(styles.err_msg,
            styles.small, err && styles.visible)}>
            {err}</div>
        </div>
    </div>;
};

const get_products = (enable_additional_usage_charges?: boolean)=>
[
    ...enable_additional_usage_charges ?
    [{
        label: <><Icon_sneakers/> Sneakers</>,
        value: Proxy_type.SNK,
    }]: [],
    {
        label: <><Icon_tickets/> Ticketing</>,
        value: Proxy_type.EV_RES,
    }
];
const default_cnf = {country: 'us', amount: 0, socks5: false};

export const Configure_proxies = (props: i_configure_proxies_props)=>{
    const {active, orders, countries, ui_config, zone_groups} = props;
    const {dashboard} = use_app_context();
    const {params, set} = use_pathname();
    const {qs, set_qs} = use_qs_with_set();
    const {theme} = useContext(Settings_context);
    const _id = params.configure_proxies;
    const item = order_by_id(orders, _id) ??
        group_order_by_id(zone_groups, _id);
    const product = useMemo(()=>{
        return get_list_of_products('toolip').find(p=>p.value==item?.type);
    }, [item?.type]);
    const item_countries = countries && countries[item?.type];
    const [loading, set_loading] = useState(false);
    const [err, set_err] = useState<string|null>(null);
    const [state, set_state] = useState<i_config_state>({
        added: [], adding: default_cnf});
    const history = useHistory();
    const ips_pool = useRef<string[]>();
    const fake = !item || !item_countries;
    const ips_used = fake ? []
        : item.generated_proxies?.filter(p=>p.manually_changed) ?? [];
    const avail_amount = fake ? 1
        : item.unit=='gb' ? 1 : item.ips_amount-ips_used.length;
    useEffect(()=>{
        if (active && orders && !item)
            set({configure_proxies: undefined, type: undefined});
    }, [active, orders, item]);
    const visible = active && !!item;
    useEffect(()=>{
        if (visible)
            document.body.classList.add('hola_modal-no_body_scroll_stack');
        else
            document.body.classList.remove('hola_modal-no_body_scroll_stack');
    }, [visible]);
    if (avail_amount<=0)
    {
        return <Redirect to={`/dashboard/page/plans`
          +`?configure_proxy=${item._id}&type=${item.type}`}/>;
    }
    const added_countries = state.added.map(a=>a.country);
    const added_codes = new Set(state.added.map(a=>a.country));
    const avail_countries = fake || item.type=='isp_plus' ? ['us'] :
        item_countries.filter(c=>!added_codes.has(c));
    const country_objects: t_country[] = useMemo(()=>
          get_country_objects(avail_countries), [avail_countries]);
    const added_amount = state.added.reduce((acc, {amount})=>acc+amount, 0);
    const max = avail_amount - added_amount;
    const update = (idx: number | null, cnf: i_config_item | null)=>{
        set_err(null);
        set_state(v=>{
            if (idx == null)
                return {...v, adding: cnf};
            return {
                ...v,
                added: cnf.amount==0
                    ? v.added.filter((_, _idx)=>_idx!=idx)
                    : v.added.map((c, i)=>i==idx ? {...c, ...cnf} : c),
            };
        });
    };
    const add = (cnf: i_config_item)=>{
        let country = country_objects.filter(c=>c.code!=cnf.country)[0]?.code;
        set_state(v=>({
            ...v,
            added: [...v.added, cnf],
            adding: {amount: 0, country, socks5: cnf.socks5},
        }));
    };
    const update_proxy = (cnf?: i_config_item)=>etask(function*(){
        let res = null;
        if (item.unit=='ip' && item.type=='shared_dc')
        {
            res = yield api.configure_proxies({id: item._id, socks5: false,
                quantity: cnf.amount, country: cnf.country});
        }
        else if (item.unit=='gb')
        {
            res = yield api.configure_proxies({id: item._id, socks5: false,
                quantity: 1, country: 'us', split: true});
        }
        else
        {
            if (!cnf.amount)
                return true;
            const ips = ips_pool.current.splice(0, cnf.amount);
            res = yield api.refresh_ips({zone_id: item._id,
                country: cnf.country, ips, socks5: cnf.socks5});
        }
        if (!res?.error)
            return true;
        set_err(res.error);
        return false;
    });
    const clear_state = ()=>{
        set_state({added: [], adding: default_cnf});
        set_err(null);
        set_loading(false);
    };
    const clear_all = ()=>{
        set({configure_proxies: undefined, type: undefined});
        set_state({added: [], adding: default_cnf});
        set_err(null);
    };
    return <div className={cn(styles.overlay,
      visible && styles.visible)} onClick={()=>{
        set({configure_proxies: undefined, type: undefined});
        set_qs({example: undefined});
      }}>
        <div className={cn(styles.configure_proxies, styles[item?.type],
          qs.example && styles.example)}
          onClick={ev=>{ ev.stopPropagation(); }}>
          <Header title={product?.title} qs={qs} set_qs={set_qs}
            clear_all={clear_all} />
          {qs.example && item && <Proxies_example update_proxy={update_proxy}
            countries={item_countries}
            ui_label_country={ui_config?.label_country}
            render_flag={ui_config?.render_flag}
            ui_add_icon={ui_config?.add_icon}
            ui_labels_always_visible={ui_config.labels_always_visible}
            order={item} loading={loading}
            refresh_orders={()=>dashboard.dispatch({type: 'refresh_orders'})}
            set_loading={set_loading} btn_loader={ui_config?.btn_loader}
            show_virtual_conf_for_gb={ui_config.show_virtual_conf_for_gb}
            clear_state={clear_state} go_to={v=>history.push(v)} />}
          {!qs.example && <Fragment>
            <div className={styles.config_table}>
              <div className={styles.config_title}>
                <span className={cn(theme.color_n700)}>
                  {ui_config.table_icon}
                  {product?.title}</span>
                <span className={cn(theme.color_n600)}>
                  {`${avail_amount}/${item?.unit=='gb'
                    ? DEFAULT_IPS_AMOUNT : fake
                    ? 1 : item?.ips_amount}`} available
                </span>
              </div>
              <div className={styles.config_items}>
                {state.added.map((cnf, idx)=>{
                  return <Config_line key={cnf.country+idx} update={update}
                    render_flag={ui_config.render_flag} add={add}
                    ui_label_country={ui_config.label_country}
                    ui_labels_always_visible={ui_config.labels_always_visible}
                    ui_add_icon={ui_config.add_icon}
                    ui_socks5_opts={ui_config.socks5_opts}
                    max={max} index={idx} value={cnf}
                    countries={[
                      get_country_object(cnf.country),
                      ...country_objects
                    ].filter(_c=>_c!=state.adding?.country)}
                  />;
                })}
                {!!avail_countries.length && (max>0 || state.adding) &&
                <Config_line key="edit" index={null} add={add} update={update}
                  render_flag={ui_config.render_flag}
                  ui_label_country={ui_config.label_country}
                  ui_labels_always_visible={ui_config.labels_always_visible}
                  ui_add_icon={ui_config.add_icon} max={max}
                  ui_socks5_opts={ui_config.socks5_opts}
                  countries={country_objects} value={state.adding}
                />}
              </div>
              <div className={cn(styles.err_msg, err && styles.visible)}>
                {err}</div>
              <div className={cn(styles.err_msg, max<0 && styles.visible)}>
                {max<0 &&
                  `You have only ${avail_amount} available proxies to add`}
              </div>
            </div>
            <div className={styles.config_bottom}>
              {(added_countries.length > 0
                || ui_config.configure_always_visible) &&
                <Button size={'md'}
                  disabled={loading || fake || max < 0
                    || added_countries.length == 0}
                  caption={loading ? ui_config.btn_loader ?? <Btn_loader/>
                    : 'Configure Proxies'}
                  cls={styles.config_btn} fit round={false}
                  color='black' no_jump on_click={()=>{
                    etask(function*(){
                      set_loading(true);
                      set_err(null);
                      if (item.unit=='ip')
                      {
                        const avail_ips = item.generated_proxies
                          .filter(p=>!p.manually_changed)
                          .map(p=>p.ip);
                        ips_pool.current = avail_ips;
                      }
                      for (let cnf of state.added)
                      {
                        const res = yield update_proxy(cnf);
                        if (!res)
                          return void set_loading(false);
                      }
                      clear_state();
                      dashboard.dispatch({type: 'refresh_orders'});
                      history.push(`/dashboard/page/plans`
                        +`/configure_proxy/${item._id}`
                        +`/type/${item.type}?success=true`);
                    });
                  }}/>}
            </div>
          </Fragment>}
        </div>
    </div>;
};

interface i_proxies_example_props {
    loading: boolean
    order: t_order
    btn_loader?: JSX.Element
    show_virtual_conf_for_gb?: boolean
    countries: string[];
    ui_add_icon?: React.ReactNode
    ui_label_country: string
    ui_labels_always_visible?: boolean
    render_flag?: (country: string)=>JSX.Element;
    go_to: (v: string)=>void
    set_loading: (v: boolean)=>void
    update_proxy: ()=>void
    clear_state: ()=>void
    refresh_orders: ()=>void
}

const Proxies_example = (props: i_proxies_example_props)=>{
    const {show_virtual_conf_for_gb, order, loading, btn_loader} = props;
    const show_virtual_config = show_virtual_conf_for_gb
        && order.unit == 'gb' && order.generated_proxies?.length;
    const [country, set_country] = useState('us');
    const [count, set_count] = useState(1);
    const [socks5, set_socks5] = useState(false);
    const {set_qs} = use_qs_with_set();
    const {set} = use_pathname();
    const configure = ()=>{
        etask(function*(){
          props.set_loading(true);
          if (show_virtual_config)
              configured_proxies_create({country, count, order, socks5});
          else
          {
              const res = yield props.update_proxy();
              if (!res)
                  return void props.set_loading(false);
          }
          props.clear_state();
          props.refresh_orders();
          set({configure_proxy: order._id, configure_proxies: undefined});
          set_qs({success: 'true'});
        });
    };
    const disabled_configure = props.loading || show_virtual_config && !count;
    return <div className={styles.config_example}>
      {show_virtual_config && <Proxies_virtual_config {...props}
        count={count} country={country} set_count={set_count}
        set_country={set_country} socks5={socks5} set_socks5={set_socks5}/>}
      <Configuration_snippet lang="curl" order={props.order} generated={[{
        login: '_login_-country-US-session-123',
        host: get_proxy_host(),
      }]} example with_line_numbers/>
      <Button size={'md'} disabled={disabled_configure}
        caption={loading ? btn_loader ?? <Btn_loader/> : 'Configure Proxies'}
        cls={styles.config_btn} fit round={false}
        color='black' no_jump on_click={configure}/>
    </div>;
};

interface i_proxies_virtual_config_props {
    countries: string[];
    ui_label_country: string
    ui_labels_always_visible?: boolean
    country: string
    count: number
    socks5: boolean
    order: t_order
    set_country: (v: string)=>void;
    set_count: (v: number)=>void;
    set_socks5: (v: boolean)=>void;
    render_flag?: (country: string)=>JSX.Element;
}

const Proxies_virtual_config = (props: i_proxies_virtual_config_props)=>{
    const {countries, render_flag, ui_label_country, ui_labels_always_visible,
        count, country, socks5, set_count, set_country, set_socks5} = props;
    const max = 10000;
    const country_objects: t_country[] = useMemo(()=>
        get_country_objects(countries), [countries]);
    const show_socks5 = props.order.unit == 'gb';
    return <div className={styles.virtual_config_line}>
      <Country_selector_v2
        all={country_objects}
        with_empty_option
        country={country}
        render_flag={render_flag}
        on_country_change={set_country}
        label={ui_labels_always_visible? ui_label_country: null}
        cls={styles.c_list}
        item_cls={styles.c_item}
        with_filter
      />
      <Input type="number" cl={styles.count_input} no_margin
        label='Proxies' value={count}
        on_change={(new_val: string)=>{
          if (+new_val < 0 || +new_val > max)
            return;
          set_count(+new_val);
        }}
        placeholder={`Up to ${max}`}/>
      {show_socks5 && <Toggle_switch options={[
        {value: false, label: 'http/https'}, {value: true, label: 'SOCKS5'}]}
        value={socks5} label='Protocol'
        on_change={set_socks5} />}
    </div>;
};

interface i_header_props {
    title: string
    clear_all: ()=>void
    set_qs: (opt: object_of<string>) => void
    qs: object_of<string>
}

const Header = (props: i_header_props)=>{
    const {title, qs, set_qs, clear_all} = props;
    const {theme} = useContext(Settings_context);
    return <div className={styles.header}>
      <p className={cn(styles.title, theme.color_n700)}>
        Proxy configuration</p>
      {qs.example ? <p className={cn(theme.color_n600,
        styles.disclaimer)}>
        <span>Your {title} partial code can be found
          here.</span>
        <span>Click on configure to get the full code and details.</span>
      </p> : <p className={cn(theme.color_n600,
        styles.disclaimer)}>
        Select the countries and number of proxies you'd like, then
        click on Configure Proxies. Please note, configuration is final
        and can't be changed.
      </p>}
      <Icon_x_close onClick={()=>{
        set_qs({example: undefined});
        clear_all();
      }} className={styles.close}/>
    </div>;
};

